import { ref } from 'vue'

export type DetectedRegion = 'Москва и МО' | 'Санкт-Петербург и ЛО' | 'Другой регион' | ''

// NOTE: геолокация определяется на стороне клиента через внешний сервис.
// В идеале следует перенести этот запрос на бэкенд, чтобы не раскрывать IP пользователя стороннему сервису.
export function useGeolocation() {
  const detectedCity = ref('')
  const region = ref<DetectedRegion>('')

  const detect = async (): Promise<void> => {
    try {
      const response = await fetch('https://free.freeipapi.com/api/json')
      const data = (await response.json()) as Record<string, string>

      const city = data['cityName'] ?? data['city'] ?? ''
      const regionName = data['regionName'] ?? data['region'] ?? ''

      if (!city) {
        console.error('Не удалось определить город, неверный формат ответа:', data)
        return
      }

      detectedCity.value = city

      if (
        regionName === 'Leningrad Oblast' ||
        regionName === 'St.-Petersburg' ||
        city === 'Saint Petersburg' ||
        city === 'Санкт-Петербург'
      ) {
        region.value = 'Санкт-Петербург и ЛО'
      } else if (
        regionName === 'Moscow' ||
        regionName === 'Moscow Oblast' ||
        city === 'Moscow' ||
        city === 'Москва'
      ) {
        region.value = 'Москва и МО'
      } else {
        region.value = 'Другой регион'
      }
    } catch {
      // Молчаливый сбой приемлем для определения геолокации
    }
  }

  return { detectedCity, region, detect }
}
